export default __webpack_public_path__ + "static/favicon-fa812e7db34fbf873556fd50ecda6c24.ico";